import React from "react";
import { Box, Typography, Grid } from "@mui/material";
import { useTranslation } from "react-i18next";
import euFlag from "assets/logos/EU-flag-fund.svg";
import styles from "./Footer.module.css";

const Footer = () => {
    const { t } = useTranslation();
    const currentYear = new Date().getFullYear();

    return (
        <footer className={styles.footerContainer}>
            <div className={styles.content}>
                <img src={euFlag} alt="EU Flag" className={styles.euFlag} />
                <Typography variant="body2" className={styles.text}>
                    {t('footer.disclaimer')}
                    <p className={styles.rights}>© {currentYear} Almende BV All rights reserved</p>
                </Typography>
            </div>
        </footer>
    );
};

export default Footer;
